module.exports = __webpack_public_path__ + "static/media/Inter-Regular.0930073e.ttf";